import { render, staticRenderFns } from "./AccordionMenu.vue?vue&type=template&id=4721145c&scoped=true&lang=pug&"
import script from "./AccordionMenu.vue?vue&type=script&lang=js&"
export * from "./AccordionMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccordionMenu.vue?vue&type=style&index=0&id=4721145c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721145c",
  null
  
)

export default component.exports